import React from 'react'

const { useViewport } = require("./hooks-viewport");
const { viewportBreakpoint } = require("./viewport-breakpoint");

const MobileViewportProvider = ({children, className}) => {
  const { width } = useViewport();
  const breakpoint = viewportBreakpoint.tablet;
  const isMobile = width < breakpoint;

  return isMobile ? (
    <div className={`${className}`}>{children}</div>
  ) : (<div className="hidden"></div>)
}

export { MobileViewportProvider }